"use client";

import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  InputLabel,
  FormControl,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const CreateBusiness = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    if (image) formData.append("image", image);

    const res = await fetch("/api/save-businessType", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        title,
        description,
        imageUrl: "", // image not uploaded yet
        status: true,
      }),
    });

    if (res.ok) {
      alert("Business type created!");
      setTitle("");
      setDescription("");
      setImage(null);
    } else {
      alert("Error creating business type");
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setImage(e.target.files[0]);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <Card sx={{ p: 2 }}>
            <CardContent>
              <Typography variant="h5" mb={3}>
                Add A Business Type
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    required
                    label="Business Type"
                    placeholder="Enter Business Type title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    required
                    multiline
                    rows={6}
                    label="Description"
                    placeholder="Type description here..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel shrink sx={{ mb: 1 }}>
                      Upload Images
                    </InputLabel>
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        padding: "30px",
                        textAlign: "center",
                        backgroundColor: "#fcfcfc",
                        cursor: "pointer",
                      }}
                    >
                      <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                        <UploadFileIcon
                          color="primary"
                          fontSize="large"
                          sx={{ mb: 1 }}
                        />
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          Drag and drop an image or{" "}
                          <span style={{ color: "#3f51b5", textDecoration: "underline" }}>
                            Browse
                          </span>
                        </Typography>
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        hidden
                        onChange={handleFileChange}
                      />
                      {image && (
                        <Typography variant="caption" mt={1}>
                          {image.name}
                        </Typography>
                      )}
                    </Box>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Buttons */}
          <Box display="flex" gap={2} mt={3}>
            <Button
              type="button"
              variant="contained"
              color="error"
              onClick={() => {
                setTitle("");
                setDescription("");
                setImage(null);
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: "#6366f1", // custom blue
                "&:hover": {
                  backgroundColor: "#4f46e5",
                },
              }}
              startIcon={<UploadFileIcon />}
            >
              + Create Business Type
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreateBusiness;
